import { render, staticRenderFns } from "./table-customer-deposit.vue?vue&type=template&id=16b62746"
import script from "./table-customer-deposit.vue?vue&type=script&lang=js"
export * from "./table-customer-deposit.vue?vue&type=script&lang=js"
import style0 from "./table-customer-deposit.vue?vue&type=style&index=0&id=16b62746&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports